import { Form, Input, Button, Typography } from 'antd'
import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { HTMLText } from '../common'
const { Title, Text } = Typography

const ConfirmEmailForm = ({
  email,
  onBackToRegister,
  onSubmit,
  onResend,
  onCheckStatus,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    // Poll the URL every 5 seconds
    const intervalId = setInterval(onCheckStatus, 5000)
    // Cleanup the interval when the component unmounts
    return () => clearInterval(intervalId)
  }, [onCheckStatus])

  return (
    <Form layout="vertical" onFinish={onSubmit} requiredMark={false}>
      <Title level={2}>
        {t('Confirm.ConfirmYourEmailCode')}
        <br />
        <strong>{t('Confirm.ConfirmTitle')}</strong>
      </Title>
      <br />
      <Text type="secondary">
        <HTMLText html={t('Confirm.SentTo').replace('{EMAIL}', email)} />{' '}
      </Text>
      <Form.Item>
        <Button className="login-form-forgot" type="link" onClick={onResend}>
          {t('Confirm.Resend')}
        </Button>
      </Form.Item>
      <Form.Item
        label={t('Confirm.Code')}
        name="code"
        className="code"
        rules={[
          {
            required: true,
            message: t('Confirm.error.PleaseEnterCode'),
          },
        ]}
      >
        <Input placeholder="" />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: '10px' }}
        >
          {t('Confirm.Confirm')}
        </Button>

        <Button type="link" onClick={onBackToRegister}>
          {t('Confirm.Cancel')}
        </Button>
      </Form.Item>
    </Form>
  )
}
export default ConfirmEmailForm
